import React, { Suspense } from "react"

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CModal from "@student_components/Modal";

import AuthProvider from "@context/AuthContext";

// ** Router Import
import Router from "./router/Router"

const App = () => {
    return (
        <Suspense fallback={null}>
            <AuthProvider >
                <ToastContainer />
                <CModal/>
                <Router />
            </AuthProvider>
        </Suspense>
    )
}

export default App
